import { action } from 'typesafe-actions'
import { Person } from '@models/person'
import {RequestData} from "@models/axios";
import {Video} from "@models/video-content";



export const enum PeopleActionTypes {
    FETCH_REQUEST = '@@people/FETCH_REQUEST',
    FETCH_SUCCESS = '@@people/FETCH_SUCCESS',
    FETCH_ERROR = '@@people/FETCH_ERROR',

    DELETE_REQUEST = '@@people/DELETE_REQUEST',
    DELETE_SUCCESS = '@@people/DELETE_SUCCESS',
    DELETE_ERROR = '@@people/DELETE_ERROR',

    CREATE_REQUEST = '@@people/CREATE_REQUEST',
    CREATE_SUCCESS = '@@people/CREATE_SUCCESS',
    CREATE_ERROR = '@@people/CREATE_ERROR',

    UPDATE_REQUEST = '@@people/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@people/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@people/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = '@@people/FETCH_ITEM_REQUEST',
    FETCH_ITEM_SUCCESS = '@@people/FETCH_ITEM_SUCCESS',
    FETCH_ITEM_ERROR = '@@people/FETCH_ITEM_ERROR',
}



export const fetchRequest = (data:RequestData) => action(PeopleActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Person[]) => action(PeopleActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(PeopleActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data:RequestData) => action(PeopleActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:any) => action(PeopleActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(PeopleActionTypes.DELETE_ERROR, message);

export const createRequest = (data:RequestData) => action(PeopleActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: Person[]) => action(PeopleActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(PeopleActionTypes.CREATE_ERROR, message);

export const updateRequest = (data:RequestData) => action(PeopleActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: Person[]) => action(PeopleActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(PeopleActionTypes.UPDATE_ERROR, message);

export const fetchItemRequest = (data:RequestData) => action(PeopleActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: Video[]) => action(PeopleActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(PeopleActionTypes.FETCH_ITEM_ERROR, message);